import { lazy, Suspense, ComponentType } from "react";

const lazyComponentLoader = (
  importComponent: () => Promise<{ default: ComponentType<any> }>
) => {
  const LazyComponent = lazy(importComponent);

  return (props: any) => (
    <Suspense fallback={null}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default lazyComponentLoader;